import { Controller } from '@hotwired/stimulus'

// Superuser bulk actions: page selection, hidden ids, row highlight.
export default class extends Controller {
  static targets = ['rowCheckbox']
  static values = { missingMessage: String }

  connect () {
    this.rowCheckboxTargets.forEach((checkbox) => {
      this.setRowSelected(checkbox, checkbox.checked)
    })
  }

  rowSelectionChanged (event) {
    const checkbox = event.currentTarget
    this.setRowSelected(checkbox, checkbox.checked)
  }

  setRowSelected (checkbox, selected) {
    const row = checkbox.closest('.workflow-execution-list-row')
    if (!row) return
    row.classList.toggle('workflow-execution-list-row--selected', selected)
  }

  selectAllOnPage () {
    this.rowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
      this.setRowSelected(checkbox, true)
    })
  }

  selectNoneOnPage () {
    this.rowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
      this.setRowSelected(checkbox, false)
    })
  }

  injectExecutionIds (event) {
    const form = event.currentTarget
    form.querySelectorAll('input[name="workflow_execution_ids[]"]').forEach(
      (existingInput) => {
        existingInput.remove()
      }
    )
    const checkedCheckboxes = this.rowCheckboxTargets.filter(
      (checkbox) => checkbox.checked
    )
    if (checkedCheckboxes.length === 0) {
      event.preventDefault()
      window.alert(this.missingMessageValue)
      return
    }
    checkedCheckboxes.forEach((checkbox) => {
      const hidden = document.createElement('input')
      hidden.type = 'hidden'
      hidden.name = 'workflow_execution_ids[]'
      hidden.value = checkbox.value
      form.appendChild(hidden)
    })
  }
}
